module.exports = __webpack_public_path__ + "img/service02.62fc1dd0.jpg";